import { PlcItem, TemplatePlcTableProps } from '@/template/interface'
import { getFormatMessage, mergeTableColumns } from '@/utils/utils'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { Modal, Space, Table } from 'antd'
import React from 'react'

const { confirm } = Modal

export const TemplatePlcTable: React.FC<TemplatePlcTableProps> = (
  props: TemplatePlcTableProps
) => {
  const formatMessage = getFormatMessage()
  const defaultColumns = [
    {
      title: formatMessage({ id: 'app.template.plc.table.index' }),
      key: 'app.template.plc.table.index',
      render: (text: any, record: any, index: any) => index + 1
    },
    {
      title: formatMessage({ id: 'app.template.plc.table.alias' }),
      key: 'app.template.plc.table.alias',
      dataIndex: 'alias'
    },
    {
      title: formatMessage({ id: 'app.template.plc.table.plcName' }),
      key: 'app.template.plc.table.plcName',
      dataIndex: 'plcName'
    },
    {
      title: formatMessage({ id: 'app.template.plc.table.communicationMode' }),
      key: 'app.template.plc.table.communicationMode',
      render: (text: any, record: PlcItem, index: any) => {
        if (record.type == 'serial') {
          return formatMessage({ id: `app.portNo.${record.serial?.portNo}` })
        }
        if (record.type == 'local') {
          return formatMessage({ id: `app.communicationMode.local` })
        }

        return `${record.ethernet?.ip || ''}:${record.ethernet?.port}`
      }
    },
    {
      title: formatMessage({ id: 'app.template.plc.table.operation' }),
      key: 'app.template.plc.table.operation',
      render: (text: any, record: PlcItem) => (
        <Space size='middle'>
          <a onClick={() => editItem(record)}>
            {formatMessage({ id: 'app.template.plc.table.operation.edit' })}
          </a>
          <a onClick={() => deleteItem(record)}>
            {formatMessage({ id: 'app.template.plc.table.operation.delete' })}
          </a>
        </Space>
      )
    }
  ]
  const columns = mergeTableColumns(defaultColumns, props.columns)
  const editItem = (item: PlcItem) => {
    if (props.onEdit) {
      props.onEdit(item)
    }
  }
  const deleteItem = (item: PlcItem) => {
    if (props.showDeleteModal) {
      confirm({
        title: formatMessage({ id: 'app.modal.confirm.delete' }),
        icon: <ExclamationCircleOutlined />,
        okText: formatMessage({ id: 'app.modal.ok' }),
        cancelText: formatMessage({ id: 'app.modal.cancel' }),
        onOk() {
          if (props.onDelete) {
            props.onDelete(item)
          }
        }
      })
    } else {
      if (props.onDelete) {
        props.onDelete(item)
      }
    }
  }

  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
      if (props.onSelect) {
        props.onSelect(selectedRows)
      }
    }
  }

  return (
    <Table
      rowKey='id'
      columns={columns}
      dataSource={props.data}
      pagination={props.pagination}
      rowSelection={
        props.selectable
          ? {
              type: props.selectionType,
              ...rowSelection
            }
          : undefined
      }
    />
  )
}
